export default __webpack_public_path__ + "static/media/logo.aa07d840.jpg";